import React, {Component} from 'react';
import Ionicon from "react-ionicons";
import GenericModal from '../../../../../common/elements/GenericModal';
import {Icon} from "in-touch-icons";
import WistiaVideoPlayer from "../../../../../common/media/WistiaVideoPlayer";
import Anchor from "../../../../../dashboardNew/objects/Anchor";

class MessageModal extends Component {

    constructor() {
        super();
        this.state = {
            message: null,
        };
    }

    handleOnSubmit(e) {
        e.preventDefault();
        const {onSave} = this.props, field = e.target.elements['message'].value;
        if(this.state.message) {
        onSave(field);
        } else {
            alert('Your message must include text')
        }
    }

    renderFormAndButtons(onClose, name) {
        return (
            <div className="video-modal sidebar">
                <span className="modal-bg-close" onClick={ () => onClose() }></span>
                <div className="modal-inner">
                    <button type="button" className="modal-close" onClick={() => onClose()}>
                        <Icon iconName={'close'} fill={'black'}/>
                    </button>
                    <p className="p-tag">Write your message to { name.first } { name.last }</p>
                    <form id="message-form" onSubmit={ (e) => {
                        this.handleOnSubmit(e)
                    } }>
                        <div className="col-12 form-group">
                            <textarea className="form-textarea" form="message-form" name="message"
                                      placeholder="Write your message" rows="5" onChange={(message) => this.setState({message})}/>
                        </div>
                        <div className="modal-foot-whole">
                            <div className="modal-foot link-cta">
                                <button type="button" className="theme-button secondary" onClick={ () => onClose() }>
                                    Cancel
                                </button>
                                <button type="submit" className="theme-button">
                                    Send
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        )
    }

    renderThankYou(name, onClose) {
        return (
            <div className="popup-default">
                <div className="popup-inner">
                    <div className="popup-content">
                <p className="p-tag text-center">Thank you, your message was sent
                    to { name.first } { name.last }</p>
                        <button className="close-popup" type="button" onClick={ () => onClose() }><Ionicon icon="ion-close"/></button>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const {name, onClose, isOpen, isThanks} = this.props;

        if (isOpen === false)
            return null;

        return (
            <div>
                { !isThanks ? this.renderFormAndButtons(onClose, name) : this.renderThankYou(name, onClose) }

            </div>
        )
    }
}

export default MessageModal;


// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/ui/MessageModal.js